import React, { useState } from 'react';
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const WheelTirePackageStaggeredCard = ({ packageData, enableUpgradeMode, isUpgradeMode }) => {

    const { image_url1, tire_image, brand_desc, vendor_id, tire_vendor_id, product_name,
        wheel_quantity, tire_quantity, front_tire_price, front_tire_size, front_tire_sku,
        front_wheel_price, front_wheel_size, front_wheel_sku, rear_tire_price, rear_tire_size,
        rear_tire_sku, rear_wheel_price, rear_wheel_size, rear_wheel_sku, front_tire_brand,
        front_tire_image, front_tire_id, rear_tire_id, package_price, front_wheel_quantity, rear_wheel_quantity,
        front_tire_quantity, rear_tire_quantity, front_bolt_pattern_metric, rear_bolt_pattern_metric,
        front_wheel_offset, rear_wheel_offset
    } = packageData;

    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const PACKAGE_QTY = 2;

    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const S3_URL = "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/";


    const getImageSrc = (url) => {
        if (!url || url.trim() === "") {
            return "https://extremeperformance.com/images/no-image-found.png";
        }
        if (url.startsWith("images/") || url.startsWith("str/")) {
            return S3_URL + url;
        }
        return url;
    };

    const wheelImage = getImageSrc(image_url1);
    const tireImage = getImageSrc(tire_image || front_tire_image);

    const safeImage =
        image_url1 &&
            !image_url1.includes("app.netsuite.com/core/media/media.nl")
            ? image_url1
            : "https://extremeperformance.com/images/no-image-found.png";

    // ==================== ADD PACKAGE TO CART ====================
    const addPackageToCart = async () => {
        setLoader(true);
        try {
            const cartItems = JSON.parse(localStorage.getItem('totalCartItems')) || {};

            // ==================== STOCK CHECK ====================
            const canAdd = checkStock(cartItems, front_wheel_sku, PACKAGE_QTY, front_wheel_quantity, "Front Wheel") &&
                checkStock(cartItems, rear_wheel_sku, PACKAGE_QTY, rear_wheel_quantity, "Rear Wheel") &&
                checkStock(cartItems, front_tire_id, PACKAGE_QTY, front_tire_quantity, "Front Tire") &&
                checkStock(cartItems, rear_tire_id, PACKAGE_QTY, rear_tire_quantity, "Rear Tire");

            if (!canAdd) {
                setLoader(false);
                return;
            }

            // ==================== ADD WHEELS ====================
            await addItem(front_wheel_sku, front_wheel_price, PACKAGE_QTY, "wheel", safeImage, vendor_id, front_wheel_quantity, `${brand_desc} ${front_wheel_size}`);
            await addItem(rear_wheel_sku, rear_wheel_price, PACKAGE_QTY, "wheel", safeImage, vendor_id, rear_wheel_quantity, `${brand_desc} ${rear_wheel_size}`);

            // ==================== ADD TIRES ====================
            await addItem(front_tire_id, front_tire_price, PACKAGE_QTY, "tires_cat", tireImage, tire_vendor_id, front_tire_quantity, `${front_tire_brand} ${front_tire_size}`);
            await addItem(rear_tire_id, rear_tire_price, PACKAGE_QTY, "tires_cat", tireImage, tire_vendor_id, rear_tire_quantity, `${front_tire_brand} ${rear_tire_size}`);

            window.dispatchEvent(new Event("cartUpdated"));

            toast.success(
                "Package Added to cart successfully!",
                {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                }
            );
        } catch (error) {
            console.error(error);
            toast.error("Failed to add package to cart");
        } finally {
            setLoader(false);
        }
    };

    // ==================== STOCK CHECK ====================
    const checkStock = (cartItems, product_id, addingQty, availableStock, itemName) => {
        const currentQty = cartItems[product_id] || 0;
        const newTotal = currentQty + addingQty;
        if (newTotal > availableStock) {
            toast.info(
                `Cannot add more ${itemName}. Only ${availableStock} available in stock!`,
                {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                }
            );
            return false;
        }
        return true;
    };

    // ==================== ADD SINGLE ITEM ====================
    const addItem = async (product_id, product_price, quantity, category_type, image, vendor_id, total_quantity, product_name) => {
        const cartItems = JSON.parse(localStorage.getItem('totalCartItems')) || {};
        const config = {
            method: 'post',
            url: `${mainUrl}/api/add-to-cart`,
            withCredentials: true,
            params: {
                product_image: image,
                product_id: product_id,
                product_name: product_name,
                product_price: product_price,
                product_quantity: quantity,
                category_type: category_type,
                total_quantity: total_quantity,
                part_number: product_id,
                vendor_id: vendor_id || ''
            },
            data: {
                cart_key: localStorage.getItem("cart-key") || '',
                user_token: localStorage.getItem("user-token") || ''
            }
        };

        const response = await axios.request(config);
        // Update Local Cart
        const existing = cartItems[product_id] || 0;
        cartItems[product_id] = existing + quantity;
        if (response.data.addCartResponse) {
            localStorage.setItem("cart-key", response.data.addCartResponse);
        }
        localStorage.setItem('totalCartItems', JSON.stringify(cartItems));
    };

    // ==================== DETAILS ====================
    // const goToWheelDetails = () => {
    //     navigate(`/wheels-product-details/${front_wheel_sku}`);
    // };

    // const goToTireDetails = () => {
    //     navigate(`/tires-details/${front_tire_id}`);
    // };

    const goToWheelDetails = () => {
        window.open(`/wheels-product-details/${front_wheel_sku}`, "_blank");
    };

    const goToTireDetails = () => {
        window.open(`/tires-details/${front_tire_id}`, "_blank");
    };

    const formatWheelSize = (size) => size?.split(/x/i).map(part => Number(part)).join("X");



    return (

        <div className="bg-white border rounded-4 shadow-sm overflow-hidden h-100">

            {/* TOP PACKAGE PRICE */}

            {/* <div
            className="d-flex justify-content-between align-items-center px-3 py-3"
            style={{
                background: "#111",
                color: "#fff"
            }}
        >

            <div>
                <div className="small text-uppercase">
                    Staggered Package
                </div>

                <div className="fw-bold">
                    Front + Rear Setup
                </div>
            </div>

            <div className="text-end">

                <div className="small">
                    Package Price
                </div>

                <div className="fw-bold fs-4 text-danger">
                    $
                    {package_price
                        ? Number(package_price).toFixed(2)
                        : '0.00'}
                </div>

            </div>

        </div> */}

            {/* IMAGES */}



            {/* DETAILS */}

            <div className="p-3">

                <div className="row">

                    {/* ================= WHEEL SECTION ================= */}

                    <div className="col-6  p-2">

                        <div className="text-center mb-3">

                            <img
                                src={wheelImage}
                                alt="wheel"
                                onClick={goToWheelDetails}
                                style={{
                                    height: "150px",
                                    objectFit: "contain",
                                    cursor: "pointer"
                                }}
                                className="img-fluid"
                            />

                        </div>

                        <div className="fw-bold text-dark mb-1">
                            {brand_desc}
                        </div>

                        {/* FRONT */}

                        <div className="bg-light rounded-3 p-1 mb-2">

                            <div className="small">
                                <strong>Front: {formatWheelSize(front_wheel_size)}</strong>
                            </div>

                            {/* <div className="fw-bold">
                                {front_wheel_size}
                            </div> */}

                            <div className="small">
                                <strong>Offset:</strong> {front_wheel_offset}
                            </div>

                            {/* <div className="small">
                                <strong>Lug Pattern:</strong> {front_bolt_pattern_metric}
                            </div> */}

                            <div className="small">
                                <strong>SKU:</strong> {front_wheel_sku}
                            </div>


                            <div className="text-danger fw-bold">
                                ${Number(front_wheel_price).toFixed(2)}
                                <span className="text-dark fw-normal">
                                    {" "}<strong>(each)</strong>
                                </span>
                            </div>

                        </div>

                        {/* REAR */}

                        <div className="bg-light rounded-3 p-1 mb-3">

                            {/* <div className="small text-muted"> */}
                            {/* <div className="small">
                                <strong> REAR:  {rear_wheel_size}</strong>
                            </div> */}

                            <div className="small">
                                <strong>REAR: {formatWheelSize(rear_wheel_size)}</strong>
                            </div>

                            {/* <div className="fw-bold">
                                {rear_wheel_size}
                            </div> */}

                            <div className="small">
                                <strong>Offset:</strong> {rear_wheel_offset}
                            </div>

                            {/* <div className="small">
                                <strong>Lug pattern: </strong> {rear_bolt_pattern_metric}
                            </div> */}

                            <div className="small">
                                <strong>SKU:</strong> {rear_wheel_sku}
                            </div>

                            <div className="text-danger fw-bold">
                                ${Number(rear_wheel_price).toFixed(2)}
                                <span className="text-dark fw-normal">
                                    {" "}<strong>(each)</strong>
                                </span>
                            </div>

                        </div>

                        {/* <div className="border-top pt-2">

                            <div className="small text-muted">
                                Wheel Set Total
                            </div>

                            <div className="fw-bold text-danger fs-5">
                                ${(
                                    front_wheel_price * 2 +
                                    rear_wheel_price * 2
                                ).toFixed(2)}
                            </div>

                        </div> */}

                    </div>

                    {/* ================= TIRE SECTION ================= */}

                    <div className="col-6 p-2">

                        <div className="text-center mb-3">

                            <img
                                src={tireImage}
                                alt="tire"
                                onClick={goToTireDetails}
                                style={{
                                    height: "150px",
                                    objectFit: "contain",
                                    cursor: "pointer"
                                }}
                                className="img-fluid"
                            />

                        </div>

                        <div className="fw-bold text-dark mb-1">
                            {front_tire_brand}
                        </div>

                        {/* FRONT */}

                        <div className="bg-light rounded-3 p-1 mb-2">

                            <div className="small">
                                <strong>FRONT:   {front_tire_size} </strong>
                            </div>

                            {/* <div className="fw-bold">
                                {front_tire_size}
                            </div> */}

                            <div className="small">
                                <strong>SKU:</strong> {front_tire_sku}
                            </div>

                            <div className="text-danger fw-bold">
                                ${Number(front_tire_price).toFixed(2)}
                                <span className="text-dark fw-normal">
                                    {" "}<strong>(each)</strong>
                                </span>
                            </div>

                        </div>

                        {/* REAR */}

                        <div className="bg-light rounded-3 p-1 mb-3">

                            <div className="small">
                                <strong> REAR:  {rear_tire_size}</strong>
                            </div>

                            {/* <div className="fw-bold">
                                {rear_tire_size}
                            </div> */}

                            <div className="small">
                                <strong>SKU:</strong> {rear_tire_sku}
                            </div>

                            <div className="text-danger fw-bold">
                                ${Number(rear_tire_price).toFixed(2)}
                                <span className="text-dark fw-normal">
                                    {" "}<strong>(each)</strong>
                                </span>
                            </div>

                        </div>

                        {/* <div className="border-top pt-2">

                            <div className="small text-muted">
                                Tire Set Total
                            </div>

                            <div className="fw-bold text-danger fs-5">
                                ${(
                                    front_tire_price * 2 +
                                    rear_tire_price * 2
                                ).toFixed(2)}
                            </div>

                        </div> */}

                    </div>
                    {!isUpgradeMode && (
                        <div className="text-center mt-2">
                            <div className="fw-bold fs-5 text-danger">
                                Package Price ${Number(package_price || 0).toFixed(2)}
                            </div>
                        </div>
                    )}

                </div>




                {/* BUTTONS */}

                <div className="d-grid gap-2 mt-4 ">

                    {!isUpgradeMode ? (

                        <button
                            className="btn btn-outline-dark rounded-pill fw-bold"
                            onClick={() => enableUpgradeMode(packageData)}
                        >
                            Upgrade Tire Option
                        </button>

                    ) : (

                        <div className="text-center fw-bold text-danger fs-5">
                            Package Price:
                            $
                            {package_price
                                ? Number(package_price).toFixed(2)
                                : '0.00'}
                        </div>

                    )}

                    {!loader ? (

                        <button
                            onClick={addPackageToCart}
                            className="btn btn-danger rounded-pill fw-bold"
                        >
                            Add Package To Cart
                        </button>

                    ) : (

                        <button
                            disabled
                            className="btn btn-secondary rounded-pill fw-bold"
                        >
                            Loading...
                        </button>

                    )}

                </div>

            </div>

        </div>

    );

};

export default WheelTirePackageStaggeredCard;
















// import React, { useState } from 'react';
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const WheelTirePackageStaggeredCard = ({ packageData, enableUpgradeMode, isUpgradeMode }) => {

//     const { image_url1, tire_image, brand_desc, vendor_id, tire_vendor_id, product_name,
//         wheel_quantity, tire_quantity, front_tire_price, front_tire_size, front_tire_sku,
//         front_wheel_price, front_wheel_size, front_wheel_sku, rear_tire_price, rear_tire_size,
//         rear_tire_sku, rear_wheel_price, rear_wheel_size, rear_wheel_sku, front_tire_brand,
//         front_tire_image, front_tire_id, rear_tire_id, package_price, front_wheel_quantity, rear_wheel_quantity,
//         front_tire_quantity, rear_tire_quantity
//     } = packageData;

//     const [loader, setLoader] = useState(false);
//     const navigate = useNavigate();
//     const PACKAGE_QTY = 2;

//     const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
//     const S3_URL = "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/";

//     const getImageSrc = (url) => {
//         if (!url || url.trim() === "") {
//             return "https://extremeperformance.com/images/no-image-found.png";
//         }
//         if (url.startsWith("images/") || url.startsWith("str/")) {
//             return S3_URL + url;
//         }
//         return url;
//     };

//     const wheelImage = getImageSrc(image_url1);
//     const tireImage = getImageSrc(tire_image || front_tire_image);

//     // ==================== ADD PACKAGE TO CART ====================
//     const addPackageToCart = async () => {
//         setLoader(true);
//         try {
//             const cartItems = JSON.parse(localStorage.getItem('totalCartItems')) || {};

//             // ==================== STOCK CHECK ====================
//             const canAdd = checkStock(cartItems, front_wheel_sku, PACKAGE_QTY, front_wheel_quantity, "Front Wheel") &&
//                 checkStock(cartItems, rear_wheel_sku, PACKAGE_QTY, rear_wheel_quantity, "Rear Wheel") &&
//                 checkStock(cartItems, front_tire_id, PACKAGE_QTY, front_tire_quantity, "Front Tire") &&
//                 checkStock(cartItems, rear_tire_id, PACKAGE_QTY, rear_tire_quantity, "Rear Tire");

//             if (!canAdd) {
//                 setLoader(false);
//                 return;
//             }

//             // ==================== ADD WHEELS ====================
//             await addItem(front_wheel_sku, front_wheel_price, PACKAGE_QTY, "wheel", wheelImage, vendor_id, front_wheel_quantity, `${brand_desc} ${front_wheel_size}`);
//             await addItem(rear_wheel_sku, rear_wheel_price, PACKAGE_QTY, "wheel", wheelImage, vendor_id, rear_wheel_quantity, `${brand_desc} ${rear_wheel_size}`);

//             // ==================== ADD TIRES ====================
//             await addItem(front_tire_id, front_tire_price, PACKAGE_QTY, "tires_cat", tireImage, tire_vendor_id, front_tire_quantity, `${front_tire_brand} ${front_tire_size}`);
//             await addItem(rear_tire_id, rear_tire_price, PACKAGE_QTY, "tires_cat", tireImage, tire_vendor_id, rear_tire_quantity, `${front_tire_brand} ${rear_tire_size}`);

//             window.dispatchEvent(new Event("cartUpdated"));

//             toast.success(
//                 "Package Added to cart successfully!",
//                 {
//                     position: "top-center",
//                     autoClose: 5000,
//                     hideProgressBar: true,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     theme: "colored",
//                 }
//             );
//         } catch (error) {
//             console.error(error);
//             toast.error("Failed to add package to cart");
//         } finally {
//             setLoader(false);
//         }
//     };

//     // ==================== STOCK CHECK ====================
//     const checkStock = (cartItems, product_id, addingQty, availableStock, itemName) => {
//         const currentQty = cartItems[product_id] || 0;
//         const newTotal = currentQty + addingQty;
//         if (newTotal > availableStock) {
//             toast.info(
//                 `Cannot add more ${itemName}. Only ${availableStock} available in stock!`,
//                 {
//                     position: "top-center",
//                     autoClose: 5000,
//                     hideProgressBar: true,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     theme: "colored",
//                 }
//             );
//             return false;
//         }
//         return true;
//     };

//     // ==================== ADD SINGLE ITEM ====================
//     const addItem = async (product_id, product_price, quantity, category_type, image, vendor_id, total_quantity, product_name) => {
//         const cartItems = JSON.parse(localStorage.getItem('totalCartItems')) || {};
//         const config = {
//             method: 'post',
//             url: `${mainUrl}/api/add-to-cart`,
//             withCredentials: true,
//             params: {
//                 product_image: image,
//                 product_id: product_id,
//                 product_name: product_name,
//                 product_price: product_price,
//                 product_quantity: quantity,
//                 category_type: category_type,
//                 total_quantity: total_quantity,
//                 part_number: product_id,
//                 vendor_id: vendor_id || ''
//             },
//             data: {
//                 cart_key: localStorage.getItem("cart-key") || '',
//                 user_token: localStorage.getItem("user-token") || ''
//             }
//         };

//         const response = await axios.request(config);
//         // Update Local Cart
//         const existing = cartItems[product_id] || 0;
//         cartItems[product_id] = existing + quantity;
//         if (response.data.addCartResponse) {
//             localStorage.setItem("cart-key", response.data.addCartResponse);
//         }
//         localStorage.setItem('totalCartItems', JSON.stringify(cartItems));
//     };

//     // ==================== DETAILS ====================
//     const goToWheelDetails = () => {
//         navigate(`/wheels-product-details/${front_wheel_sku}`);
//     };

//     const goToTireDetails = () => {
//         navigate(`/tires-details/${front_tire_id}`);
//     };



//     return (

//         <div className="package-card border bg-white p-3 h-100">

//             <div className="row g-3">

//                 {/* ==================== WHEEL ==================== */}
//                 <div className="col-6 text-start">

//                     <img
//                         src={wheelImage}
//                         alt="wheel"
//                         style={{
//                             height: "130px",
//                             objectFit: "contain",
//                             cursor: "pointer"
//                         }}
//                         className="mb-2"
//                         onClick={goToWheelDetails}
//                     />

//                     <h6>
//                         <strong>
//                             Front: {front_wheel_size}
//                         </strong>
//                     </h6>

//                     <p>SKU: {front_wheel_sku}</p>

//                     <p className="small">
//                         <strong>
//                             Price:
//                             <span className="text-danger">
//                                 ${Number(front_wheel_price).toFixed(2)}
//                             </span>
//                             (Each)
//                         </strong>
//                     </p>

//                     <hr
//                         style={{
//                             borderTop: "1px solid #ccc",
//                             margin: "4px 0"
//                         }}
//                     />

//                     <h6 className="mt-2">
//                         <strong>
//                             Rear: {rear_wheel_size}
//                         </strong>
//                     </h6>

//                     <p>SKU: {rear_wheel_sku}</p>

//                     <p className="small">
//                         <strong>
//                             Price:
//                             <span className="text-danger">
//                                 ${Number(rear_wheel_price).toFixed(2)}
//                             </span>
//                             (Each)
//                         </strong>
//                     </p>

//                     <p className="small">
//                         <strong>Brand:</strong> {brand_desc}
//                     </p>

//                     <p className="small">
//                         <strong>
//                             Set of 4:
//                             <span className="text-danger">
//                                 ${(
//                                     front_wheel_price * 2 +
//                                     rear_wheel_price * 2
//                                 ).toFixed(2)}
//                             </span>
//                         </strong>
//                     </p>
//                 </div>

//                 {/* ==================== TIRE ==================== */}
//                 <div className="col-6 text-start">

//                     <img
//                         src={tireImage}
//                         alt="tire"
//                         style={{
//                             height: "130px",
//                             objectFit: "contain",
//                             cursor: "pointer"
//                         }}
//                         className="mb-2"
//                         onClick={goToTireDetails}
//                     />

//                     <h6>
//                         <strong>
//                             Front: {front_tire_size}
//                         </strong>
//                     </h6>

//                     <p>Item Ref: {front_tire_sku}</p>

//                     <p className="small">
//                         <strong>
//                             Price:
//                             <span className="text-danger">
//                                 ${Number(front_tire_price).toFixed(2)}
//                             </span>
//                             (Each)
//                         </strong>
//                     </p>

//                     <hr
//                         style={{
//                             borderTop: "1px solid #ccc",
//                             margin: "4px 0"
//                         }}
//                     />

//                     <h6 className="mt-2">
//                         <strong>
//                             Rear: {rear_tire_size}
//                         </strong>
//                     </h6>

//                     <p>Item Ref: {rear_tire_sku}</p>

//                     <p className="small">
//                         <strong>
//                             Price:
//                             <span className="text-danger">
//                                 ${Number(rear_tire_price).toFixed(2)}
//                             </span>
//                             (Each)
//                         </strong>
//                     </p>

//                     <p className="small">
//                         <strong>Brand:</strong> {front_tire_brand}
//                     </p>

//                     <p className="small">
//                         <strong>
//                             Set of 4:
//                             <span className="text-danger">
//                                 ${(
//                                     front_tire_price * 2 +
//                                     rear_tire_price * 2
//                                 ).toFixed(2)}
//                             </span>
//                         </strong>
//                     </p>
//                 </div>
//             </div>

//             {/* ==================== PACKAGE PRICE ==================== */}
//             {!isUpgradeMode && (
//                 <div className="text-center my-3">
//                     <h6 className="text-danger fw-bold">
//                         Package Price : $
//                         {package_price
//                             ? Number(package_price).toFixed(2)
//                             : '0.00'}
//                     </h6>
//                 </div>
//             )}

//             {/* ==================== BUTTONS ==================== */}
//             <div className="d-flex flex-column flex-sm-row gap-2 justify-content-between border-top py-2">

//                 {!isUpgradeMode ? (
//                     <button
//                         className="btn btn-secondary"
//                         onClick={() => enableUpgradeMode(packageData)}
//                     >
//                         Upgrade Tire Option For This Wheel
//                     </button>
//                 ) : (
//                     <div className="fw-bold text-danger fs-5 text-center">
//                         Package Price: $
//                         {package_price
//                             ? Number(package_price).toFixed(2)
//                             : '0.00'}
//                     </div>
//                 )}

//                 {!loader ? (
//                     <button
//                         onClick={addPackageToCart}
//                         className="package-cart"
//                     >
//                         Add to Cart
//                     </button>
//                 ) : (
//                     <button
//                         disabled
//                         className="btn btn-secondary"
//                     >
//                         Loading...
//                     </button>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default WheelTirePackageStaggeredCard;